import React, { Component } from 'react';
import { Table } from 'semantic-ui-react';
import { ItemTableHeaderRow, ItemTableRow } from './ItemTableRow';

export default class ItemTable extends Component {

    render() {
        const {items} = this.props;

        return (
            <Table celled striped sortable unstackable>
                <Table.Header>
                    <ItemTableHeaderRow />
                </Table.Header>
                <Table.Body>
                    {items.map( i => { return ( <ItemTableRow key={i._id} item={i} /> )})}
                </Table.Body>
            </Table>
        )
    }
};


// WEBPACK FOOTER //
// ./src/items/index/ItemTable.jsx